export const MAX_NUMBER_OF_LABELS = 200;

export const NUMBER_OF_LABELS_TO_SHOW_ON_VIDEO_CARD = 3;
